<template>
  <div>
    <!-- 需求审批流程-发起审批 -->
    <el-card>
      <el-row>
        <el-col :span="24">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/RAP/myApproveListRAP' }">需求审批流程</el-breadcrumb-item>
            <el-breadcrumb-item>发起审批</el-breadcrumb-item>
          </el-breadcrumb>
        </el-col>
      </el-row>
      <el-divider></el-divider>
      <div class="content_box">
        <div>
          <el-steps :active="level" align-center>
            <el-step v-for="(item, index) in TimeLines" :key="index" :title="item.Name" :status="item.Result">
              <template slot="description">
                <div>{{item.CompletedTime}}</div>
                <div>{{item.Handler}}</div>
                <div>{{item.ResultMessage}}</div>
              </template>
            </el-step>
          </el-steps>
        </div>
        <div class="feund_form">
          <div class="title_1">需求审批流程核查表</div>
          <el-form ref="RAP_form" :model="RAP_form" label-position="left" label-width="100px" :rules="formRules">
            <el-row :gutter="40">
              <el-col :span="11">
                <el-form-item label="编号" prop="NeedNo" label-width="80px">
                  <el-col :span="18">
                    <el-input disabled v-model="RAP_form.NeedNo" placeholder="请点击获取编号"></el-input>
                  </el-col>
                  <el-col :span="2">
                    <el-button type="primary" size="small" @click="GetNeedNo()">获取编号</el-button>
                  </el-col>
                </el-form-item>
                <el-form-item label="主题" prop="Theme">
                  <el-input v-model="RAP_form.Theme" placeholder="请填写主题" ></el-input>
                </el-form-item>
                <el-form-item label="需求类型" prop="TypeName">
                  <el-cascader style="width: 100%;" v-model="becauseArray" :options="options"
                    :props="{ expandTrigger: 'hover' }" @change="handleBeacuseOfChange"></el-cascader>
                </el-form-item>
                <el-form-item label="项目名称" prop="ProjectName">
                  <el-input v-model="RAP_form.ProjectName" placeholder="请填写项目名称"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="13">
                <el-form-item label="需求部门名称" prop="DepartmentName" label-width="135px">
                  <el-input disabled v-model="RAP_form.DepartmentName" placeholder="请填写需求部门名称"></el-input>
                </el-form-item>
                <el-form-item label="是否公司级需求" prop="IsCompany" label-width="135px">
                  <el-select @change="handleIsCompanyChange" style="width: 100%;" v-model="RAP_form.IsCompany" placeholder="请选择是否公司级需求">
                    <el-option label="是" value="1"></el-option>
                    <el-option label="否" value="0"></el-option>
                  </el-select>
                </el-form-item>
                <!-- @blur="blurIsLimitTime()" -->
                <el-form-item label="是否限制交付时间" prop="IsLimitTime" label-width="135px">
                  <el-select @change="handleIsLimitTimeChange" style="width: 100%;" v-model="RAP_form.IsLimitTime" placeholder="请选择是否限制交付时间"  >
                    <el-option label="是" value="1"></el-option>
                    <el-option label="否" value="0"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="预期交付日期" label-width="135px" v-show="IsLimitTimeFlag">
                  <el-date-picker @change="getMyDate" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="选择日期" v-model="RAP_form.GiveDate" style="width: 100%;" ></el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-form-item label="主要问题" prop="MainQuestion">
                <el-input type="textarea" v-model="RAP_form.MainQuestion" placeholder="请填写主要问题"></el-input>
              </el-form-item>
              <el-form-item label="使用范围" prop="UseRange">
                <el-input type="textarea" v-model="RAP_form.UseRange" placeholder="请填写使用范围"></el-input>
              </el-form-item>
              <el-form-item label="影响范围" prop="EffectRange">
                <el-input type="textarea" v-model="RAP_form.EffectRange" placeholder="请填写影响范围"></el-input>
              </el-form-item>
              <el-form-item label="预期价值" prop="ExpectedValue">
                <el-input type="textarea" v-model="RAP_form.ExpectedValue" placeholder="请填写预估价值"></el-input>
              </el-form-item>
            </el-row>
            <!-- 分割线 -->
            <el-divider></el-divider>
            <div class="title_1">申请所需资料</div>
            <el-row :gutter="40">
              <el-col :span="11">
                <!-- 退款确认书 -->
                <el-form-item label="请上传附件" label-width="120px">
                  <el-upload
                    style="float:left;"
                    class="upload-demo"
                    action="http://flow.text.ruizhiqi.com/api/public/needflow/UploadFile"
                    :on-success="handleSuccessRAPConfirmation"
                    :on-preview="handlePreview"
                    :on-remove="handleRemove"
                    :before-remove="beforeRemove"
                    :limit="1"
                    :on-exceed="handleExceed"
                    :file-list="fileList"
                    >
                    <el-button slot="trigger" size="small" type="primary">点击上传</el-button>
                    <!-- <el-button style="margin-left: 10px;" size="small" type="success" @click="download_doc()" >下载模板</el-button> -->
                    <!-- <div slot="tip" class="el-upload__tip">
                      需加盖红色公章
                    </div> -->
                  </el-upload>
                </el-form-item>
              </el-col>
            </el-row>
            <!-- 分割线 -->
            <el-divider></el-divider>
            <el-form-item style="float:right;margin-bottom:40px;">
              <el-button type="primary" @click="submitForm(RAP_form)">提交申请</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </el-card>
  </div>
</template>
<script>
import { GetFlowSendNextSteps,Excuteflow } from "../../until/ZeusApiSDK/Logic/RefundLogic";
import { GetNeedNo,RAPInformationsAdd,GetStepTimeLine,GetRAPFlowSendNextSteps } from "../../until/ZeusApiSDK/Logic/RAPLogic.js";
import { cryptoDecode } from "../../until/encrypt.js"
export default {
  data() {
    return {
      userInfo: {},
      tabIndex: 0,
			becauseArray : [],
      IsLimitTimeFlag : false,
      myDate : '',
      TimeLines: [],
      level: 0,
			options:[
				{
					value: '内部支持',
					label: '内部支持',
					children: [
						{
							value: '活动类',
							label: '活动类',
						},
						{
							value: '政策类',
							label: '政策类',
						},
						{
							value: '服务类',
							label: '服务类',
						}
					]
				},
				{
					value: '行业平台',
					label: '行业平台',
					children: [
						{
							value: '装馨家',
							label: '装馨家',
						},
						{
							value: '锐房在线',
							label: '锐房在线',
						},
						{
							value: '效律平台',
							label: '效律平台',
						},
						{
							value: '知了好学',
							label: '知了好学',
            },
            {
							value: '爱采购',
							label: '爱采购',
						}
					]
				},
				{
					value: '自主产品',
					label: '自主产品',
					children: [
						{
							value: '舆情平台',
							label: '舆情平台',
						},
						{
							value: '小程序',
							label: '小程序',
						},
						{
							value: '定制化服务',
							label: '定制化服务',
						}
					]
				},
			],
      RAP_form: {
        AddUserId : '',       //添加人id
        AddUserCode : '',     //添加人工号
        AddTrueName : '',     //添加人真实姓名
        NeedNo : '',          //编号
        Theme : '',           //主题
        ProjectName : '',     //项目名称
        TypeName : '',        //一级需求类型名称
        CateName : '',        //二级需求类型名称
        DepartmentId : '',    //需求部门id
        DepartmentName : '',  //需求部门名称
        MainQuestion : '',    //主要问题
        UseRange : '',        //使用范围
        EffectRange : '',     //影响范围
        ExpectedValue : '',   //预期价值
        IsCompany  : '',      //是否公司级需求 0否 1是
        IsLimitTime : '',     //是否限制交付时间 0否；1是
        GiveDate : '',        //预期交付日期
        LastGiveDate : '',    //最终确认交付日期 在发起表单的时候要为空
        Attachment : ''       //需求附件
      },
      formRules: {
        NeedNo: [
          { required: true, message: "请点击获取编号", trigger: "blur" }
        ],
        Theme: [
          { required: true, message: "请填写主题", trigger: "blur" }
        ],
        DepartmentName: [
          { required: true, message: "请填写需求部门名称", trigger: "blur" }
        ],
        ProjectName: [
          { required: true, message: "请填写项目名称", trigger: "change" }
        ],
        IsCompany: [
          { required: true, message: "请选择是否公司级需求", trigger: "change" }
        ],
        IsLimitTime: [
          { required: true, message: "请选择是否限制交付时间", trigger: "change" }
        ],
        TypeName: [
          { required: true, message: "请选择需求类型", trigger: "change" }
        ],
        ProjectName: [
          { required: true, message: "请填写项目名称", trigger: "blur" }
        ],
        MainQuestion: [
          { required: true, message: "请填写主要问题", trigger: "blur" }
        ],
        UseRange: [
          { required: true, message: "请填写使用范围", trigger: "blur" }
        ],
        EffectRange: [
          { required: true, message: "请填写影响范围", trigger: "blur" }
        ],
        ExpectedValue: [
          { required: true, message: "请填写预估价值", trigger: "blur" }
        ]
      },
      fileList: [],
    };
  },
  methods: {
    async GetNeedNo(){
      var res = await GetNeedNo();
      if(res.Result == 200){
        this.RAP_form.NeedNo = res.Data;
        this.$message({
          message: '获取成功~',
          type: 'success'
        });
      }else{
        this.$message.error('获取失败,请重新获取');
      }
    },
    //监听是否公司级要求
    handleIsCompanyChange(val){
      this.RAP_form.IsCompany = val;
    },
    // 监听是否限制交付时间
    handleIsLimitTimeChange(val){
      if(val == 1){
        this.IsLimitTimeFlag = true;
      }else{
        this.IsLimitTimeFlag = false;
      }
      this.RAP_form.IsLimitTime = val;
    },
    getMyDate(time) {
    },
    // 下载模板
    // download_doc(file_name) {
    //   window.open("http://tuikuan.text.ruizhiqi.com/download/【模板】退款确认书（郑州）.docx");
    // },
    //提交表单
    async submitForm(form) {
      this.$refs["RAP_form"].validate(async valid => {
        if (valid) {
          await RAPInformationsAdd(this.RAP_form).then(res => {
            var InfomationId = res.Data;
            // 获取发送时的下面步骤集合
            GetRAPFlowSendNextSteps(this.userInfo.UserId,"f98ba941-ba98-464d-859f-c9252b2dc075",InfomationId).then(res => {
              var paras = {
                flowid: "0a41fb67-42d2-4d71-bbf9-acf79a334a1a",
                //当前用户id
                senderid: this.userInfo.UserId,
                data: [
                  {
                    field: "Types",
                    value: '需求审批流程'
                  }
                ],
                instanceid: InfomationId,
                step: [
                  {
                    id: res[0].Step.ID,
                    member: res[0].DefaultMemberID
                  }
                ],
                type: "submit",
                isfirststep: true,
                taskid: "",
                stepid: res[0].DefaultMemberID,
                comment: '',
                groupid: this.userInfo.FrameId,
                title: this.RAP_form.Theme,//this.userInfo.TrueName + "需求审批流程申请",
                ccid: "",
                ccname: "",
                sendername: this.userInfo.TrueName
              };
              Excuteflow(paras).then(res => {
                //最后跳转路由
                this.$message({
                  message: "发起审批成功",
                  type: "success"
                });
                this.$router.push("/RAP/myRAPList");
              });
            });
          });
        } else {
          this.$message.error("表单提交失败！");
          return false;
        }
      });
    },
    handleBeacuseOfChange(value) {
      this.RAP_form.TypeName = value[0];
      this.RAP_form.CateName = value[1];
		},
    /**
     * 上传所需退款资料 start
     */
    // 退款确认书
    handleSuccessRAPConfirmation(response) {
      if( response.Result == 200 ){
        this.$message({
          message: "上传附件成功",
          type: "success"
        });
        this.RAP_form.Attachment = response.Data;
      }else{
        this.$message.error("上传附件失败");
      }
    },
    handleRemove(file, fileList) {
    },
    handlePreview(file) {
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 3 个文件，本次选择了 ${
          files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      );
    },
    beforeRemove(file) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    //动态获取步骤条 
    async GetStepTimeLine(){
      await GetStepTimeLine(this.userInfo.UserId,'').then(res => {
        res.TimeLines.forEach(e => {
          if (e.Result == '0') {
            e.Result = "wait";
          } else if (e.Result == 2) {
            e.Result = "finish";
          } else if (e.Result == 3) {
            e.Result = "error";
          } else if (e.Result == 4) {
            e.Result = "finish";
          } else if (e.Result == 5) {
            e.Result = "error";
          }
        });
        this.TimeLines = res.TimeLines;
        this.level = res.NowStep;
      });
    }
    
    /**
     * 上传所需退款资料 end
     */
  },
  created() {
    var userinfo = JSON.parse(cryptoDecode(window.sessionStorage.getItem('userinfo')));
    this.userInfo = userinfo;
    this.RAP_form.DepartmentName = userinfo.FrameName;
    this.RAP_form.AddUserId = userinfo.UserId;
    this.RAP_form.AddUserCode = userinfo.UserCode;
    this.RAP_form.AddTrueName = userinfo.TrueName;
    this.RAP_form.DepartmentId = userinfo.FrameId;
    this.GetStepTimeLine();
  }
};
</script>
<style lang="less" scoped>
.box-card {
  margin-top: 20px;
}
.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both;
}

//下拉菜单
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}

//content_area
.content_box {
  margin-top: 15px;
  .feund_form {
    height: 600px;
    width: 100%;
    .title_1 {
      text-align: left;
      height: 44xp;
      line-height: 44px;
      margin-bottom: 20px;
      font-weight: 500;
    }
  }
}
.el-upload__tip {
  float: right;
  margin-left: 16px;
  transform: translateY(-6px);
}
</style>
